import React from 'react';
import defaultContext from './defaultContext';

const AppContext = React.createContext({
  locale: defaultContext.defaultLng,
  currentPage: '',
  currentApplication: 0, // 0 CM, 1 BE, 2 RM
  setLocale: () => {},
  setCurrentPage: () => {},
  setCurrentApplication: () => {},
});

export default AppContext;
